import React, { useState,useEffect } from "react";
import styled from "styled-components";
import SwipeableContent from "../common/SwipeableContent.jsx";
import GovWalletBanner from "./GovWalletBanner.jsx"
import { fonts } from "../common/mixins.js";
import Icon from "../common/Icon.jsx";
import Ticket from "./Ticket.jsx";
import Product from "./Product.jsx";
import useMediaQuery from "@mui/material/useMediaQuery";

const Title = styled.div`
  ${fonts.normalTextSmall()};
  display: flex;
  gap: 4px;
  align-items: center;
  line-height: 24px;
  margin-bottom: ${props => props.hasLabel ? "4px" : "16px"};
  justify-content: ${props => props.hasGovWallet ? "space-between" : "flex-start"};
`;

const TitleContent = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const AuthStatus = styled.div`
  font-family: 'pf_highway_sans_pro_lightRg';
  color: #FCB041;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  gap: 4px;
  align-items: center;
`;

export default function Tickets({ tickets, products = [], reservationExpired, orderStatus, hasGovWallet}) {
    const [hasLabel, setHasLabel] = useState(false);
    const [productHasLabel, setProductHasLabel] = useState(false);
    const countPendingGovTickets = (tickets) => {
        return tickets.filter(ticket => ticket.govStatus === 'PE')
    }
    const pendingGovTickets = countPendingGovTickets(tickets).length;
    const isDesktop = useMediaQuery("(min-width:1024px)");

    useEffect(() => {

        const hasLabelArea = (items) => {
            return items.some(item => item.status === 'PE' || item.status === 'CN');
        }; 

        if (tickets) {
            const hasLabel = hasLabelArea(tickets);
            setHasLabel(hasLabel);
        }
        if (products) {
            const producthasLabel = hasLabelArea(products);
            setProductHasLabel(producthasLabel);
        }
    }, [tickets, products]);
    return (
        <>
            {hasGovWallet && <GovWalletBanner />}
            {(tickets && tickets.length > 0 && products && products.length > 0) ||
                tickets.some((ticket) => ticket.status === "PE") || pendingGovTickets>0 ? (
                <Title hasLabel={hasLabel} hasGovWallet={hasGovWallet}>
                    <TitleContent>
                        <Icon kind="ticket" />
                        {orderdetails_resources.Tickets}
                    </TitleContent>                     
                    {hasGovWallet && <AuthStatus><Icon kind="auth-needed" />{`${pendingGovTickets}/${tickets.length}`}  {orderdetails_resources.RequiresVerificationGov}</AuthStatus>}               
                </Title>
            ) : null}
 

            <div style={{ width: "100%", marginBottom: isDesktop && products.length === 0 ? "117px" : "24px", height: "100%" }}>
                <SwipeableContent type="tickets" hasLabel={hasLabel}>
                    {tickets.map((item, index) => (
                        <Ticket
                            key={index}
                            data={item}
                            count={{
                                item: index + 1,
                                total: tickets.length,
                            }}
                            hasLabel={hasLabel}
                            orderStatus={orderStatus}
                        />
                    ))}
                </SwipeableContent>
            </div>

            {products && products.length > 0 ? (
                <div style={{ width: "100%", marginBottom: isDesktop ? "117px" : "24px" }}>
                    {tickets && tickets.length > 0 && products && products.length > 0 ? (
                        <Title hasLabel={productHasLabel}>
                            <Icon kind="product-black" />
                            {orderdetails_resources.Products}
                        </Title>
                    ) : null}
                    <SwipeableContent type="products">
                        {products.map((item, index) => (
                            <Product
                                key={index}
                                data={item}
                                count={{
                                    item: index + 1,
                                    total: products.length,
                                }}
                                hasLabel={productHasLabel}
                                orderStatus={orderStatus}
                            />
                        ))}
                    </SwipeableContent>
                </div>
            ) : null}
        </>
    );
}

   

  